import { NgModule } from "@angular/core";

import { OnlyWithDirective } from "../directive/only-with.directive";

    /**
     * @description
     *  Módulo principal de directivas.
     */

@NgModule({
    declarations: [OnlyWithDirective],
    exports: [OnlyWithDirective],
	imports: [],
	providers: []
})
export class DirectiveModule {}
